namespace Portico.Services {

    import pme = Portico.Models.Enterprise;
	import psga = apigateway.client;
    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;

	export interface INoteService {
		getTask(taskId: number): angular.IPromise<pme.Task>;
		getTasks(taskIds: number[]): angular.IPromise<pme.Task[]>;
    }

    @Service('app', 'noteService')
	@Inject('$q', 'NotesV2Api')
	export class NoteService implements INoteService {
        constructor(
            private $q: angular.IQService,
			private noteApi: psga.NotesV2Api
        ) { }

        getTask(taskId: number): angular.IPromise<pme.Task> {
			// TODO: wrap in an edge call
			return this.$q.when(this.noteApi.taskGetByProgramId(taskId).then((response) => {
				response.data.data.completionDate = <moment.Moment><unknown>response.data.data.completionDate?.toDate();
				response.data.data.createdDate = <moment.Moment><unknown>response.data.data.createdDate?.toDate();
				response.data.data.dueDate = <moment.Moment><unknown>response.data.data.dueDate?.toDate();
				response.data.data.updatedDate = <moment.Moment><unknown>response.data.data.updatedDate?.toDate();
				return new pme.Task(response.data.data);
            }));
        }

		getTasks(taskIds: number[]): angular.IPromise<pme.Task[]> {
			const promises: angular.IPromise<void>[] = [];
			const tasks: pme.Task[] = [];

			for (const taskId of taskIds) {
				const promise = this.getTask(taskId).then((response) => {
					tasks.push(new pme.Task(response));
				});

				promises.push(promise);
			}

			return this.$q.all(promises).then(() => {
				return tasks;
			});
		}

		//populate(account: pme.Account): angular.IPromise<boolean> {
		//	const promises: angular.IPromise<void>[] = [];

		//	for (const task of account.tasks) {
		//		const promise = this.getTask(task.id).then((response) => {
		//			angular.copy(response, task);
		//		});

		//		promises.push(promise);
		//	}

		//	return this.$q.all(promises).then(() => {
		//		return true;
		//	});
		//}
    }
}